<template>
  <li>
    <div class="cover_wrap">
      <a
        class="thum_wrap"
        :data-bg-color="formattedColor"
        @click="navigateDetail()"
      >
        <span class="meta_title">{{ selfbook.title }}</span>
        <span
          v-if="['stopped', 'editing'].includes(formattedStatus)"
          :class="{
            'meta_state not': formattedStatus === 'stopped',
            'meta_state ing': formattedStatus === 'editing'
          }"
        >
        </span>
      </a>
    </div>
    <div v-if="mode === 'view'" class="info_wrap">
      <a @click="navigateDetail()">
        <h3 class="meta_title">{{ selfbook.title }}</h3>
      </a>
      <p>
        <span class="meta_date">
          <span v-if="formattedStatus === 'editing'">{{
            $t('base.baseselfbook.6645')
          }}</span>
          <span v-if="formattedStatus === 'selling'">{{
            $t('base.baseselfbook.951')
          }}</span>
          <span v-if="formattedStatus === 'stopped'">{{
            $t('base.baseselfbook.2055')
          }}</span>
          <span> {{ formattedDate }}</span>
        </span>
      </p>
    </div>
  </li>
</template>

<script>
// import moment from 'moment'

const colorMapping = {
  A: 'blue',
  B: 'orange',
  C: 'green'
}

/* pending */
const statusMapping = {
  SU: 'stopped',
  ED: 'editing',
  SA: 'selling'
}

export default {
  props: {
    selfbook: {
      type: Object,
      required: true
    },
    mode: {
      /* ['edit', 'view'] */
      type: String,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    // formattedDate() {
    //   if (!this.selfbook || !this.selfbook.date) return
    //   return moment(this.selfbook.publishDate).lang('ko').format('LL')
    // },
    formattedColor() {
      if (!this.selfbook || !this.selfbook.color) {
        return 'blue'
      }
      return colorMapping[this.selfbook.color]
    },
    formattedStatus() {
      if (!this.selfbook.status) {
        return 'editing'
      }
      return statusMapping[this.selfbook.status]
    }
  },
  methods: {
    navigateDetail() {
      this.$router.push({
        name: 'selfbook_detail',
        params: {
          id: this.selfbook.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.meta_date {
  display: inline !important;
}
</style>
